import React from 'react'
import PropTypes from 'prop-types'
import HeroBannerContent from './HeroBannerContent'
import DebtReliefCard from './DebtReliefCard'
import TestimonialCard from './TestimonialCard'
import Img from 'src/components/shared/Img'

const HeroBannerClientPoints = ({
  content,
  isDefaultLang,
  useTestimonialFormat,
  isMobileVariantBActive = true,
  heroPerson = null,
  heroPersonV2 = null,
  invertDivOrder = false,
}) => (
  <div className="bg-secondary">
    <div
      className={`mx-auto flex max-w-[1219px] items-center justify-center pt-0 pb-6 lg:py-6`}
      data-testid="home-hero-section"
      id="hero-banner"
    >
      <div className="size-full relative isolate flex flex-wrap">
        {isMobileVariantBActive && (
          <div className="relative block h-60 w-full shrink-0 sm:hidden">
            <Img
              src={
                isDefaultLang
                  ? '/next-assets/brand-pages/home/patti.webp'
                  : '/next-assets/brand-pages/home/patti-spanish.jpg'
              }
              alt="woman with long brown hair smiling because she has found debt relief"
              height={240}
              width={640}
              priority={true}
              isBackgroundImage={true}
              objectFit="cover"
              className="size-full block"
              imgClassName="object-top"
              layout="responsive"
            />
          </div>
        )}

        <div
          className={`flex w-full flex-col lg:flex-row ${
            invertDivOrder ? 'lg:flex-row-reverse' : ''
          }`}
        >
          <div
            className={`lg:w-188 w-full px-5 pt-0 sm:pt-10 lg:p-10 ${
              content?.belowButtonText ? 'pt-[1.4rem]!' : ''
            }`}
          >
            <HeroBannerContent
              isMobileVariantBActive={isMobileVariantBActive}
              content={content}
              isDefaultLang={isDefaultLang}
            />
          </div>

          <div className="sm:w-full lg:w-132">
            {useTestimonialFormat ? (
              <TestimonialCard
                heroPersonV2={heroPersonV2}
                isMobileVariantBActive={isMobileVariantBActive}
              />
            ) : (
              <DebtReliefCard heroPerson={heroPerson} />
            )}
          </div>
        </div>
      </div>
    </div>
  </div>
)

HeroBannerClientPoints.defaultProps = {
  isDefaultLang: true,
  useTestimonialFormat: false,
  invertDivOrder: false,
}

HeroBannerClientPoints.propTypes = {
  content: PropTypes.object.isRequired,
  isDefaultLang: PropTypes.bool,
  useTestimonialFormat: PropTypes.bool,
  invertDivOrder: PropTypes.bool,
}

export default HeroBannerClientPoints
